export function normalizeAppStatus(status) {
  const value = String(status || "").toLowerCase()
  if (["completed", "installed"].includes(value)) return "installed"
  if (["approved", "inprogress", "in-progress"].includes(value)) return "installing"
  if (["pending", "requested"].includes(value)) return "pending"
  if (value === "rejected") return "rejected"
  if (value === "failed") return "failed"
  if (value === "uninstalled") return "uninstalled"
  return value || "pending"
}

export function appStatusLabel(status) {
  const value = normalizeAppStatus(status)
  if (value === "installed") return "Installed"
  if (value === "installing") return "Installing"
  if (value === "pending") return "Requested"
  if (value === "rejected") return "Rejected"
  if (value === "failed") return "Failed"
  if (value === "uninstalled") return "Uninstalled"
  return status || "—"
}

const looksLikePackageId = (value) => {
  const text = String(value || "").trim()
  return Boolean(text) && !/\s/.test(text)
}

export function collectPackageIds(item = {}) {
  const nested = item?.appData && typeof item.appData === "object" ? item.appData : {}
  const explicit = [
    item.packageId,
    item.PackageId,
    nested.packageId,
    nested.PackageId,
    item.Id,
    nested.Id,
  ].filter(looksLikePackageId)
  if (explicit.length) return explicit.map((value) => String(value).trim())
  return [nested.appName, item.appName, item.name]
    .filter(looksLikePackageId)
    .map((value) => String(value).trim())
}

export function requestPackageId(item = {}) {
  return collectPackageIds(item)[0] || ""
}

export function samePackage(left, right) {
  const leftIds = new Set(collectPackageIds(left).map((id) => id.toLowerCase()))
  const rightIds = collectPackageIds(right).map((id) => id.toLowerCase())
  return leftIds.size > 0 && rightIds.some((id) => leftIds.has(id))
}
